<template>
  <div>
    <home-page :isTarget="true" />
    <!-- 顶部 -->
    <div class="flex flex-space-between">
      <van-search
        class="wpercent60"
        v-model="searchValue"
        @input="searchFunction"
        @clear="searchFunction"
        @search="searchFunction"
        placeholder="姓名/手机号"
      />
      <van-dropdown-menu class="wperenct40" active-color="#008c8c">
        <van-dropdown-item
          v-model="dropdownValue"
          :options="dropdownList"
          @change="searchFunction"
        />
      </van-dropdown-menu>
    </div>
    <van-divider :style="{ borderColor: '#008c8c', margin: 0 }" />
    <candidate :listData="listData" @click="deleteObj" />
    <!-- 应用组件添加候选人弹窗 -->
    <add-candidate :visible="addVisible" />
    <div class="wpercent100 bottom0 fixed">
        <bottom-btn @click="btnClick" />
      </div>
  </div>
</template>

<script>
import addCandidate from "@/views/components/dialog/addCandidate.vue";
import candidate from "@/views/components/card/candidate.vue";
import HomePage from "@/views/home/HomePage.vue"
import BottomBtn from "@/components/basic/bottomBtn.vue";
import { Dialog, Toast } from "vant";
export default {
  components: {
    addCandidate,
    candidate,
    HomePage,
    BottomBtn,
  },
  data() {
    return {
      dropdownList: [
        { text: "全部", value: 0 },
        { text: "待面试", value: 1 },
        { text: "面试成功", value: 2 },
        { text: "面试失败", value: 3 },
      ],
      // 添加候选人
      addVisible: [],
      // 搜索 基础对象
      searchObj: {
        pageSize: 10,
        pageNum: 1,
        projectId: -1,
      },
      // 列表数据
      listData: [
        {
          fullName: "张三",
          gender: "1",
          age: 29,
          updataBy: "2020-07-28",
          mobile: "18930585485",
          dataStata: "待面试",
          interviewstatas: 0,
          id: 10215,
        },
        {
          fullName: "李四",
          gender: "0",
          age: 29,
          updataBy: "2023-07-28",
          mobile: "18930589999",
          dataStata: "面试成功",
          interviewstatas: 1,
          id: 30258,
        },
        {
          fullName: "张三丰",
          gender: "1",
          age: 29,
          updataBy: "2205-07-28",
          mobile: "19930585485",
          dataStata: "面试失败",
          interviewstatas: 1,
          id: 51548,
        },
      ],
      // searchValue
      searchValue: '',
      //  筛选dropdownValue
      dropdownValue: 0,
      // 删除弹窗显示隐藏
      showDeleteDialog: false,
    };
  },
  methods: {
    // 获取列表数据
    getListData(){

    },
    // 搜索方法
    searchFunction(){
      const searchValue = {
        searchValue: this.searchValue,
      };
      const dropdownValue = {
        dropdownValue: this.dropdownValue,
      };
      this.searchObj = {...this.searchObj, ...searchValue, ...dropdownValue};
      console.log(this.searchObj, '搜索对象');
      this.getListData();
    },
    // 操作按钮
    deleteObj(obj) {
      if(obj.interviewstatas === 0){
      this.showDeleteDialog = true;
      this.confirmDelete(obj);
      } else {
        Toast.fail('状态已锁定，不可删除！');
      }
    },
    // 确认删除彈窗 確認操作
    confirmDelete(obj) {
      Dialog.setDefaultOptions({
        confirmButtonColor: '#008c8c',
      });
      Dialog.confirm({
        title: "刪除候选人",
        message: "确认删除候选人？",
      })
        .then(() => {
          console.warn('刪除確認', obj);
          Toast('刪除成功！');
          this.getListData();
        })
        .catch(() => {
          console.warn('刪除取消');
        });
    },
    lookValue(value) {
      console.log(value, 'input', this.searchValue);
    },
    // 底部按钮
    btnClick(val) {
      const r = Math.random(); // 触发 组件 更新
      if (val === "leftText") {
        this.$router.replace({
          path: `/home`,
          query: { r },
        });
      } else {
        this.addVisible = [r, true];
      }
    },
  },
};
</script>

<style lang="less">
.van-dialog__message--has-title {
  padding-top: 24px;
}
.van-dialog__header {
  border-bottom: 1px solid #bec4c4;
  padding-top: 10px;
  padding-left: 15px;
  font-weight: normal;
  line-height: 24px;
  text-align: left;
}
.van-dialog__message {
  font-size: 18px;
  line-height: 70px;
}
.van-dialog__footer {
  border-top: 1px solid #bec4c4;
}

</style>
